import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

import Input from "../input";
import Button from "../button";
import Newsletter from "./index";

const StyledForm = styled.form`
  color: #fff;
  &  label span:first-child {
    font-size: 1rem!important;
    font-family: "Big Caslon", serif;

  }
`;

const Flex = styled.div`
  display: flex;
  align-items: flex-end;
  & > button {
    border-left: none;
    color: #fff;
  }
  & input {
    width: 100%;
    background-color: transparent;
    border-color: #fff;
    color: #fff;
    &::placeholder {
      color: rgba(255, 255, 255, 0.9);
    }
  }
`;

const Privacy = styled.div`
  margin-top: 16px;
  text-align: left;
  font-family: "Big Caslon", serif;
  color: #fff;
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  color: #fff;
`;

const CheckboxInput = styled.input`
  margin: 3px 8px 0 0;
  cursor: pointer;
  accent-color: #fff;
`;

const PrivacyText = styled.span`
  font-size: 0.875rem;
  font-family: "Big Caslon", serif;
  line-height: 1.4;
  color: #fff;
  a {
    color: #fff;
    text-decoration: underline;
    &:hover {
      opacity: 0.8;
    }
  }
`;

const SuccessMessage = styled.div`
  font-family: "Big Caslon", serif;
  font-size: 0.9rem;
  padding: 8px 0;
  font-style: italic;
  color: #fff;
`;

const ErrorMessage = styled.div`
  font-family: "Big Caslon", serif;
  font-size: 0.9rem;
  color: #ff0000;
  padding: 8px 0;
`;

const NewsletterContact = () => {
  return (
    <Newsletter>
      {({
        email,
        setEmail,
        checked,
        setChecked,
        showPrivacyError,
        setShowPrivacyError,
        isSubmitting,
        isSuccess,
        error,
        handleSubmit,
      }) => {
        if (isSuccess) {
          return <SuccessMessage>Thank you for subscribing to our newsletter!</SuccessMessage>;
        }

        return (
          <StyledForm onSubmit={handleSubmit} autoComplete="off">
            <Flex>
              <Input
                onChange={(value) => setEmail(value)}
                value={email}
                label="Newsletter"
                placeholder="email"
                type="email"
                name="email"
                disabled={isSubmitting}
                required
              />
              <Button
                name="submit"
                type="submit"
                disabled={isSubmitting}
                css={`
                  border-color: #fff;
                  &:hover:not(:disabled) {
                    background-color: #fff;
                    color: #000;
                  }
                `}
              >
                {isSubmitting ? "sending..." : "send"}
              </Button>
            </Flex>
            <Privacy>
              <CheckboxContainer>
                <CheckboxInput
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => {
                    setChecked(e.target.checked);
                    if (e.target.checked) {
                      setShowPrivacyError(false);
                    }
                  }}
                  name="privacy-policy"
                  required
                />
                <PrivacyText>
                  I have read and accept the{" "}
                  <Link to="/legal/privacy-policy">privacy policy</Link>.
                </PrivacyText>
              </CheckboxContainer>
            </Privacy>
            {showPrivacyError && (
              <ErrorMessage>
                Please accept the terms and conditions to continue.
              </ErrorMessage>
            )}
            {error && <ErrorMessage>{error}</ErrorMessage>}
          </StyledForm>
        );
      }}
    </Newsletter>
  );
};

export default NewsletterContact; 